module.exports = __webpack_public_path__ + "static/media/x-circle.0872bc7c.svg";